import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getAppDetailsByAppKeys } from '@atlassian/amkt-addon-discovery';
import { FREE_PRICING, PAID_PRICING } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';
import { useEffect, useState } from 'react';
import { getEmceeLocation } from '../../../../services/AP';
import { getAppRequestComments, getAppRequests } from '../../../../services/AppRequests';
export const useAppRequests = (bootstrapConfig, algoliaClient, appRequestDefaultParams) => {
  if (!appRequestDefaultParams.cloudId) {
    return {
      appRequestsError: "Couldn't fetch cloud id  from Host info",
      appRequestsPending: false,
      appRequestsResult: null
    };
  }
  const appRequestPromise = async () => {
    const appRequestsRes = await getAppRequests(appRequestDefaultParams.productName, appRequestDefaultParams.cloudId);
    const appRequestsWithoutAppDetails = appRequestsRes.allAppRequestDetails;
    const appDetails = await getAppDetailsByAppKeys(algoliaClient, bootstrapConfig.algolia.environment, appRequestsWithoutAppDetails.map(appRequest => appRequest.appKey));
    const appDetailsMap = appDetails.content.hits.reduce((result, hit) => {
      result[hit.addonKey] = {
        logo: "".concat(bootstrapConfig.mpacCdnBaseUrl, "/product-listing/files/").concat(hit.logo.image),
        name: hit.name,
        priceType: hit.version.paid ? PAID_PRICING : FREE_PRICING,
        appKey: hit.addonKey,
        ratings: {
          avgStars: hit.ratings.avgStars,
          numRatings: hit.ratings.numRatings
        },
        activeInstalls: hit.distribution.activeInstalls,
        downloads: hit.distribution.downloads
      };
      return result;
    }, {});
    const appRequests = appRequestsWithoutAppDetails.filter(appRequestWithoutAppDetails => {
      const hasAlgoliaReturnedDetails = !!appDetailsMap[appRequestWithoutAppDetails.appKey];
      if (!hasAlgoliaReturnedDetails) {
        log.error('ManageAppRequests/hooks', "Algolia returned no result for AppKey: ".concat(appRequestWithoutAppDetails.appKey));
      }
      return hasAlgoliaReturnedDetails;
    }).map(appRequestWithoutAppDetails => _objectSpread(_objectSpread({}, appRequestWithoutAppDetails), {}, {
      appDetails: appDetailsMap[appRequestWithoutAppDetails.appKey]
    }));
    return appRequests;
  };
  const {
    result,
    error,
    pending
  } = hooks.usePromise(appRequestPromise);
  if (error) {
    log.error('ManageAppRequests/hooks', "Failed to retrieve App requests", {
      error
    });
  }
  return {
    appRequestsPending: pending,
    appRequestsError: error,
    appRequestsResult: result
  };
};
export const useEmceeBaseUrl = mountPath => {
  const [emceeBaseUrl, setEmceeBaseUrl] = useState('');
  useEffect(() => {
    getEmceeLocation(_ref => {
      let {
        baseURL
      } = _ref;
      return setEmceeBaseUrl(baseURL);
    }, mountPath);
  }, []);
  return emceeBaseUrl;
};
export const useAppRequestComments = appRequestCommentsParams => {
  var _result$appRequestDet;
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => getAppRequestComments(appRequestCommentsParams));
  if (error) {
    log.error('ManageAppRequests/hooks', "Failed to retrieve App request comments", {
      error
    });
  }
  return {
    pending,
    error,
    comments: (_result$appRequestDet = result === null || result === void 0 ? void 0 : result.appRequestDetails) !== null && _result$appRequestDet !== void 0 ? _result$appRequestDet : []
  };
};